import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  wrap: {
    marginBottom: 24,
    marginTop: 0,
  },
  error: {
    backgroundColor: 'red',
  },
  dialogContainer: {
    padding: 48,
    minWidth: 500,
  },
  subHeader: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    marginBottom: 8,
    textAlign: 'center',
  },
  content: {
    padding: 24,
  },
  buttonMargin: {
    marginLeft: 24,
  },
  dialogButton: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 16,
  },
  container: {
    padding: 24,
    marginTop: 10,
    marginBottom: 32,
    borderRadius: 5,
    backgroundColor: theme.palette.common.white,
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'end',
    paddingTop: 8,
  },
  header: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  list: {
    paddingLeft: 16,
    listStyleType: 'disc',
  },
  attachmentList: {
    display: 'flex',
    marginTop: 16,
  },
  attachmentHeader: {
    marginRight: 48,
  },
  attachmentLink: {
    color: 'rgba(67, 134, 229, 1)',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginRight: 16,
  },
}));
